<template>
  <el-drawer
    :visible="visible"
    :direction="direction"
    @close="closeDrawer"
    :size="size"
  >
    <template>
      <el-card shadow="never" v-if="isDisplaySerialNumber">
        <div>
          <info-table
            :field-arr="productField"
            :table-data="[rowData]"
          ></info-table>
          <div style="padding-top:20px;">
            <el-form
              :inline="true"
              :model="formInline"
              class="demo-form-inline"
            >
              <el-form-item>
                <span>快速查询：</span>
              </el-form-item>
              <el-form-item label="">
                <el-input
                  v-model="formInline.value"
                  placeholder="请输入关键字"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="onSubmit"
                >查询
                </el-button>
                <el-button
                  plain
                  @click="onSubmit('reset')"
                >重置
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="item-box-add" style="margin-top:20px;">
            <el-row style="margin-bottom:20px">
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  <span style="padding:0px 0 14px 0;">仓储录入产品序列号</span>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-bottom:30px;">
              <div
                class="no-contet"
                style="text-align:center;margin-top:20px;"
                v-if="tableData.length===0"
              >暂无产品序列号</div>
              <el-col
                :span="6"
                v-for="(item,i) in tableData"
                :key="i"
                style="padding:10px 10px;border:1px solid #ebeef5"
              >
                <div class="grid-content bg-purple">{{ item }}</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-card>
      <slot></slot>
    </template>
  </el-drawer>
</template>

<script>
import infoTable from '@/components/module/infoTable'
import { deepClone } from '@/util'

export default {
  name: 'checkDrawer',
  components: {
    infoTable
  },
  methods: {
    onSubmit (reset) {
      let { value } = this.formInline
      if (reset === 'reset') {
        this.formInline.value = ''
        value = ''
      }
      this.tableData = this.targetTableData.filter(item => item.includes(value))
    },
    closeDrawer () {
      this.$emit('update:visible', false)
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  },
  data () {
    return {
      formInline: {},
      tableData: [],
      targetTableData: []
    }
  },
  props: {
    direction: {
      type: String,
      default: 'rtl'
    },
    visible: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '40%'
    },
    rowData: {
      type: Object,
      default: () => {
      }
    },
    isDisplaySerialNumber: {
      type: Boolean,
      default: true
    },
    productField: {
      type: Array,
      default: () => ([{
        label: '品牌',
        name: 'brandName'
      }, {
        label: '型号',
        name: 'proType'
      }, {
        label: '订货号',
        name: 'orderNumber'
      }, {
        label: '数量',
        name: 'count'
      }])
    }
  },
  watch: {
    rowData: {
      handler (newVal) {
        const { proSerialNumber } = newVal
        if (proSerialNumber) {
          if (proSerialNumber.includes(',')) {
            this.tableData = proSerialNumber.split(',')
          } else if (proSerialNumber.includes(';')) {
            this.tableData = proSerialNumber.split(';')
          }
          this.targetTableData = deepClone(this.tableData)
        }
      },
      deep: true
    }
  }
}
</script>

<style
  scoped
  lang="less"
>
  /deep/ .el-card {
    border: 0;
  }

  /deep/ .el-drawer__header {
    margin-bottom: 0;

    & > :first-child {
      display: none;
    }
  }

  h5,
  h4 {
    text-align: center !important;
  }
  h5 {
    margin: 0px !important;
    font-size: 14px;
  }
  .join-inquiry-list-drawer {
    padding: 20px;
    color: #83878a;
    font-size: 14px !important;
    .join-inquier-list-crumbs {
      padding-left: 20px;
      font-size: 14px;
      span:first-child {
        color: #4e555b;
        padding-right: 10px;
      }
    }
    .join-inquier-list-product {
      padding: 30px 0 0 30px;
      .item-box-add {
        margin: 0 0 30px 0;
        .title-font-style {
          margin-bottom: 20px;
          font-weight: bold;
          font-size: 16px;
          color: #4e555b;
        }
        .serial_list {
          border: 1px solid #ebeef6;
          height: 500px;
          margin-top: 15px;
          width: 100%;
          display: flex;
          align-content: flex-start;
          justify-content: flex-start;
          flex-wrap: wrap;
          .serial_list_item {
            border-right: 1px solid #ebeef6;
            border-bottom: 1px solid #ebeef6;
            width: 16.5%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            &:nth-child(6n) {
              border-right: none;
            }
          }
        }
      }
    }
    .dialog-footer {
      width: 180px;
      margin: 30px auto;
      float: right;
    }
  }
  /deep/ :focus {
    outline: 0;
  }
</style>
